export default () => {
  const triggers = document.querySelectorAll('.js-blur')

  ;[...triggers].forEach(trigger => {
    trigger.addEventListener('blur', e => {
      trigger.classList.add('active')
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Blur.js